export default "__VITE_ASSET__DIJv3ys8__"